module.exports = __webpack_public_path__ + "static/media/card1.a837870f.png";